function isInactive(row = {}) {
  return Boolean(
    row.inactive === true ||
      row.excluded === true ||
      row?.flags?.inactive === true ||
      row?.flags?.excluded === true ||
      row?.meta?.inactive === true ||
      row?.meta?.excluded === true
  );
}

export function groupEstimateRows(rows = []) {
  const map = new Map();

  for (const row of rows || []) {
    const inactive = isInactive(row);
    const label = row.label || row.name || "Untitled row";
    const unit = row.unit || "";
    const type = row.type || row.rowKind || "";

    const key = `${type}_${label}_${unit}_${inactive ? "inactive" : "active"}`;

    if (!map.has(key)) {
      map.set(key, {
        ...row,
        id: `group_${key}`,
        type,
        label,
        name: label,
        unit,
        quantity: 0,
        total: 0,
        active: !inactive,
        inactive,
        excluded: inactive,
        sources: [],
        childRows: [],
        flags: {
          ...(row.flags || {}),
          active: !inactive,
          inactive,
          excluded: inactive,
          reviewRequired: false,
        },
        meta: {
          ...(row.meta || {}),
          active: !inactive,
          inactive,
          excluded: inactive,
          grouped: true,
        },
      });
    }

    const grouped = map.get(key);

    grouped.quantity += Number(row.quantity || row.qty || row.hours || 0);
    grouped.total += Number(row.total || 0);

    const hasInvalidPrice =
      Number(row?.unitPrice ?? row?.price ?? row?.hourlyRate ?? row?.rate ?? 0) <=
        0 || Number(row?.total ?? 0) <= 0;

    grouped.flags.reviewRequired =
      grouped.flags.reviewRequired ||
      row?.reviewRequired === true ||
      row?.flags?.reviewRequired === true ||
      row?.flags?.invalidPrice === true ||
      row?.meta?.review === true ||
      hasInvalidPrice;

    grouped.reviewRequired = grouped.flags.reviewRequired;

    const sourceLabel = row?.meta?.sourceLabel;
    if (sourceLabel && !grouped.sources.includes(sourceLabel)) {
      grouped.sources.push(sourceLabel);
    }

    grouped.childRows.push(row);
  }

  return Array.from(map.values()).map((row) => ({
    ...row,
    quantity: Number(row.quantity.toFixed(2)),
    total: Number(row.total.toFixed(2)),
  }));
}